'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Event handler that is invoked when the `addtrack` event is fired
 * on the video track list.  This handler is used when using the 
 * config type of `ConfigTypes.SAFARI_DESKTOP` or `ConfigTypes.IOS`.
 *
 * @param {Object} event  
 *        Event object forwarded to the event handler.
 * 
 * @param {Function} callback
 *        Callback function to be invoked when `cuechange`
 *        event is heard on the track.
 */
var handleAddNativeTrack = exports.handleAddNativeTrack = function handleAddNativeTrack(track, callback) {
    // We only want to add cuechange listeners to metadata tracks.
    // We don't check for track.label to equal `Timed Metadata`
    // because it is set to an empty string in desktop Safari
    // NOTE: checking for label segment-metadata is only a factor
    //       when using the iOS emulator in desktop chrome.  Avoiding
    //       script errors while listening for cue events on the 
    //       wrong tracks when testing.
    if (track.kind !== 'metadata' || track.label == 'segment-metadata') {
        return false;
    }

    // Setting track mode to `hidden` is required in desktop Safari
    // and iOS in order to hear the cuechange event fired on the track.
    track.mode = 'hidden';

    // A cuechange event fires when the player crosses over an ID3 tag:
    // we're going to use oncuechange instead of addEventListener so that
    // we don't add multiple listeners to the same track WN-3315
    track.oncuechange = function () {
        callback(track);
    };
};

/**
 * Event handler that is invoked when the `addtrack` event is fired
 * on the video track list.  This handler is used when using the 
 * config type of `ConfigTypes.DEFAULT`.
 *
 * @param {Object} event  
 *        Event object forwarded to the event handler.
 * 
 * @param {Function} callback
 *        Callback function to be invoked when `cuechange`
 *        event is heard on the track.
 */
var handleAddEmulatedTrack = exports.handleAddEmulatedTrack = function handleAddEmulatedTrack(track, callback) {
    // We only want to add cuechange listeners to metadata tracks.
    // Chrome adds the tracks as they come in and Safari adds them on load.
    // Possible difference in using native vs emulated videojs tracks.
    if (track.kind !== 'metadata' || track.label !== 'Timed Metadata') {
        return false;
    }

    // a cuechange event fires when the player crosses over an ID3 tag:
    return track.on('cuechange', function () {
        callback(track);
    });
};